import React from "react";
import { PlusIcon } from "lucide-react";
import { PrimaryButton } from "@/shared/components/ui/Button/PrimaryButton";

const formatTotalValue = (val) => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  }).format(val);
};

const DealsHeader = ({ openCount, totalValue, setShowCreateDeal }) => {
  return (
    <div className="flex w-full h-fit justify-between items-center pb-4">
      <div className="flex flex-col gap-1">
        <h1 className="text-[1.375rem] text-gray-900 font-bold leading-7">
          All Deals
        </h1>
        <p className="text-sm text-gray-500 font-normal">
          {openCount} open {openCount === 1 ? "deal" : "deals"} <span className="mx-1.5 text-gray-300">•</span> {formatTotalValue(totalValue)} total value
        </p>
      </div>
      <PrimaryButton
        startContent={<PlusIcon size={16} color="#fff" />}
        onClick={() => setShowCreateDeal(true)}
      >
        New Deal
      </PrimaryButton>
    </div>
  );
};

export default DealsHeader;
